// ToolbarExtension.js
import MyExtension from '../viewerExtensions/MyExtension';
const { Autodesk } = window;


class ToolbarExtension extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        this.viewer = viewer;
        this._toolbar = null;
        this._group = null;
        this._button1 = null;
        this._button2 = null;
        this._button3 = null;
        // Track whether MyExtension is loaded
        this._myExtensionLoaded = false;
    }

    load() {
        console.log('ToolbarExtension loaded');
        this.onToolbarCreated();
        return true;
    }

    unload() {
        console.log('ToolbarExtension unloaded');
        if (this._toolbar) {
            this.viewer.container.removeChild(this._toolbar.container);
            this._toolbar = null;
        }
        return true;
    }

    onToolbarCreated() {
        // Create a new toolbar with vertical alignment.
        this._toolbar = new Autodesk.Viewing.UI.ToolBar('myCustomToolbar', { alignVertically: true });
        // Create a control group.
        this._group = new Autodesk.Viewing.UI.ControlGroup('myCustomGroup');

        // Button 1: Toggle MyExtension (using Bootstrap icons as background via CSS)
        this._button1 = new Autodesk.Viewing.UI.Button('myCustomButton1');
        // Initially, show toggle off state.
        this._button1.addClass('bi');
        this._button1.addClass('bi-toggle-off');
        this._button1.setToolTip('Toggle MyExtension');
        this._button1.onClick = async () => {
            const { Autodesk } = window;
            if (this._myExtensionLoaded) {
                // Unload MyExtension using a promise wrapper for consistency.
                new Promise((resolve, reject) => {
                    const result = this.viewer.unloadExtension("MyExtension");
                    result ? resolve(result) : reject("Error unloading MyExtension");
                })
                    .then(() => {
                        Autodesk.Viewing.theExtensionManager.unregisterExtension("MyExtension");
                        console.log("MyExtension unloaded and unregistered");
                        this._myExtensionLoaded = false;
                        this._button1.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
                    })
                    .catch((err) => console.error(err));
            } else {
                // Use isAvailable() to check if the extension is already registered.
                if (Autodesk.Viewing.theExtensionManager.isAvailable("MyExtension")) {
                    Autodesk.Viewing.theExtensionManager.unregisterExtension("MyExtension");
                    console.log("Stale MyExtension unregistered (using isAvailable)");
                }

                // Register the extension using the global MyExtension class.
                const registrationResult = Autodesk.Viewing.theExtensionManager.registerExtension(
                    "MyExtension",
                    window.MyExtension
                );
                if (registrationResult) {
                    console.log("MyExtension registered");
                    try {
                        // Await the asynchronous loading of the extension.
                        await this.viewer.loadExtension("MyExtension");
                        console.log("MyExtension loaded successfully");
                        this._myExtensionLoaded = true;
                        this._button1.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
                    } catch (err) {
                        console.error("Error loading MyExtension:", err);
                    }
                } else {
                    console.error("Error registering MyExtension");
                }
            }
        };




        // Button 2: Simple button that logs a message.
        this._button2 = new Autodesk.Viewing.UI.Button('myCustomButton2');
        this._button2.addClass('bi');
        this._button2.addClass('bi-bell');
        this._button2.setToolTip('Button 22');
        this._button2.onClick = () => {
            alert('Button 22 clicked!');
        };

        // Button 3: Another simple button.
        this._button3 = new Autodesk.Viewing.UI.Button('myCustomButton3');
        this._button3.addClass('bi');
        this._button3.addClass('bi-cup');
        this._button3.setToolTip('Button 33');
        this._button3.onClick = () => {
            alert('Button 33 clicked!');
        };

        // Add buttons to the control group.
        this._group.addControl(this._button1);
        this._group.addControl(this._button2);
        this._group.addControl(this._button3);
        // Add the control group to the toolbar.
        this._toolbar.addControl(this._group);
        // Append the toolbar to the viewer container.
        this.viewer.container.appendChild(this._toolbar.container);
    }
}

Autodesk.Viewing.theExtensionManager.registerExtension('ToolbarExtension', ToolbarExtension);
window.ToolbarExtension = ToolbarExtension;
